import { useMemo } from "react";
import Apis from "serviceapi/ApiImports";
import { OPCUAApi } from "../../../serviceapi/dataCollectorApi";

/**
 * The OPC UA endpoints live on the Data Collector service, so the client is always built
 * with the "datacollector" base URL regardless of which page the header was opened from.
 */
export const useOpcUaApi = () => {
  const opcUaApi = useMemo(
    () => Apis("datacollector").opcUaApi as OPCUAApi,
    []
  );

  return { opcUaApi };
};
